<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Device Diagnostic Profiles</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="()=>{selectedProfile=null; dialogSwitch = true}">
                    Add
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Created at</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="profile in profiles" v-if="profiles.length" :key="profile.id" class="text-left">
                        <td>{{ profile.name }}</td>
                        <td>{{ formatDateTime(profile.created_at) }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <v-btn class="text-warning" size="x-small"
                                       @click="editProfile(profile)">Edit
                                </v-btn>
                                <v-btn class="text-error" size="x-small"
                                       @click="deleteProfile(profile)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" colspan="4">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="4">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @update:model-value="fetchAssets"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <Create_Edit v-if="dialogSwitch"
                 v-model="dialogSwitch"
                 :profile="selectedProfile"
                 @addProfile="addProfile"
                 @updateProfile="updateProfile"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {formatDateTime} from '@/composables/useTimezone';
import Create_Edit from "@/components/dialogs/devices/diagnostics/Profile_Create_Edit.vue";

const profiles = ref([]);
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const dialogSwitch = ref(false);
const selectedProfile = ref(null);
const {showSnackbar} = useSnackbarStore();

onMounted(() => {
    fetchProfiles();
});

const fetchProfiles = () => {
    send('get', `admin/diagnostics/profiles`, {page: currentPage.value})
        .then((response) => {
            profiles.value = response.data.data.data;
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Device diagnostic profiles could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const addProfile = (profile) => {
    profiles.value.unshift(profile);
}
const editProfile = (profile) => {
    selectedProfile.value = profile;
    dialogSwitch.value = true;
}
const updateProfile = (profile) => {
    profiles.value.map((item, index) => {
        if (item.id === profile.id) {
            profiles.value[index] = profile;
        }
    });
}
const deleteProfile = (profile) => {
    if (confirm(`Are you sure to delete "${profile.title}" profile?`)) {
        send('delete', `admin/diagnostics/profiles/${profile.id}`)
            .then((response) => {
                if (response.data.success) {
                    profiles.value.map((item, index) => {
                        if (item.id === profile.id) {
                            profiles.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${profile.title}" device diagnostic profile could not be deleted`, 'error')
                }
            })
    }
}
</script>
